/**
 * Sign in scene
 * 
 * @author Mautilus s.r.o.
 * @class Scene_Search
 * @extends Scene
 */

Scene_Search = (function(Scene) {

	var Scene_Search = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Scene_Search.prototype, Scene.prototype, {
		/**
		 * @inheritdoc Scene#init
		 */
		init: function(){
			console.log('[Scene] init ' + this.name + ' scene');

			this.snippetSearch = new Snippet_Search(this, {});
		},
		
		/**
		 * @inheritdoc Scene#create
		 */
		create: function() {
			return $('#scene-search');
		},
		
		/**
		 * @inheritdoc Scene#activate
		 */
		activate: function() {
			console.log('[Activate] ' + this.name);
			// if ( Device.isWEBOS ) {
			// 	Device.clearHistory();
			//   Device.pushHistory();
			// }

			return Promise.resolve();
		},
        
		/**
		 * @inheritdoc Scene#render
		 */
		render: function() {
            this.$el.find('.issueLogin').text(__('issue_login'));
			this.snippetSearch.render();
		},

		/**
		 * @inheritdoc Scene#onClick
		 */
		onClick: function($el, event) {
			if(this.trigger('click', $el, event) === false) {
				return false;
			}
			return this.onEnter.apply(this, arguments);
		},
		/**
		 * @inheritdoc Scene#onEnter
		 */
		onEnter: function($el, event) {
		},
		/**
		 * @inheritdoc Scene#onReturn
		 */
		onReturn: function($el, event) {
			if ( App.dialog ) {
				App.dialog.onClose();
				return false;
			}
			Router.goBack();
			return false;
		},
		/**
		 * @inheritdoc Scene#navigate
		 */
		navigate: function(direction) {
		},
		
		/**
		 * @inheritdoc Scene#focus
		 */
		focus: function() {
			// Focus.to(this);
		},
		
		/**
		 * @inheritdoc Scene#onBeforeGoBack
		 */
		onBeforeGoBack: function(fromScene) {
			this.dontRedraw = true;
		},
		
		/**
		 * Cascade focus. Manage the process of Focus delegation between snippets inside Scene
		 * 
		 * @param {Object} Snippet or jQuery
		 * @param {String} direction of Focus delegation ("up", "down", "left", "right")
		 */
		onFocusOut: function (snippet, direction) {
		}

	});

	return Scene_Search;

})(Scene);


//////////////////
// WEBPACK FOOTER
// ./js/scene/search.js
// module id = 57
// module chunks = 0